import { containerConnect } from "@configuratorware/configurator-frontendgui/Framework/ComponentContainer";
import CategorySelectorDialog from "../../Components/CategorySelectorDialog/CategorySelectorDialog";
import { fetchCategories, setSelectedCategoryId } from "../../Reducers/Products/Actions";

const mapStateToProps = (state) => {
  return {
    Component: CategorySelectorDialog,
    isLoggedIn: state.login.isLoggedIn,
    categories: state.products.categories,
    basketItems: state.basket.items
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchCategories: () => dispatch(fetchCategories()),
  setSelectedCategoryId: (id: number) => dispatch(setSelectedCategoryId(id))
});

export default containerConnect(mapStateToProps, mapDispatchToProps);
